import { USERS_ROUTES } from '../../constants/_routes'
import usersTypes from '../../constants/usersTypes'
import { axios } from '../../services'
import { current_timestamp } from '../../helpers'

// INDEX
const users_index_request = () => {
  return {
    type: usersTypes.index.request
  }
}

const users_index_success = (response) => {
  return {
    type: usersTypes.index.success,
    payload: response.data
  }
}

const users_index_failure = (messages) => {
  return {
    type: usersTypes.index.failure,
    payload: messages
  }
}

const users_index = (page=1, per_page=10, filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(users_index_request())

    // Request
    axios.get(
      USERS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: per_page,
          sort: sort,
          order: order,
          filters: filters,
          serial: current_timestamp()
        }
      }
    ).then( response => {
      // success
      dispatch( users_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching users."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( users_index_failure(errors))
    })
  }

}

const users_select_success = (response) => {
  return {
    type: usersTypes.index.select,
    payload: response.data
  }
}


const users_select = () => {
  return function (dispatch) {
    // Before Request
    dispatch(users_index_request())

    // Request
    axios.get(
      USERS_ROUTES.select
    ).then( response => {
      // success
      dispatch( users_select_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching users."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( users_index_failure(errors))
    })
  }
}

export {
  users_index,
  users_select
}



// WEBPACK FOOTER //
// ./src/js/actions/users/getindex.js